export const emptyAsNull = <T extends object>(obj: T | EmptyObject) => {
  if (obj && typeof obj === "object" && Object.keys(obj).length === 0) {
    return null;
  }
  return obj as T;
};
